/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { DateSearch } from './DateSearch';
import {
    DateSearchFromJSON,
    DateSearchFromJSONTyped,
    DateSearchToJSON,
} from './DateSearch';
import type { Int32NullableListSearch } from './Int32NullableListSearch';
import {
    Int32NullableListSearchFromJSON,
    Int32NullableListSearchFromJSONTyped,
    Int32NullableListSearchToJSON,
} from './Int32NullableListSearch';
import type { UnaccentTextSearch } from './UnaccentTextSearch';
import {
    UnaccentTextSearchFromJSON,
    UnaccentTextSearchFromJSONTyped,
    UnaccentTextSearchToJSON,
} from './UnaccentTextSearch';

/**
 * 
 * @export
 * @interface SiegeLieuSuiviFichierSearchDto
 */
export interface SiegeLieuSuiviFichierSearchDto {
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof SiegeLieuSuiviFichierSearchDto
     */
    fileName?: UnaccentTextSearch;
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof SiegeLieuSuiviFichierSearchDto
     */
    uploadUser?: UnaccentTextSearch;
    /**
     * 
     * @type {DateSearch}
     * @memberof SiegeLieuSuiviFichierSearchDto
     */
    uploadDate?: DateSearch;
    /**
     * 
     * @type {Int32NullableListSearch}
     * @memberof SiegeLieuSuiviFichierSearchDto
     */
    idtypeSuiviFichier?: Int32NullableListSearch;
    /**
     * 
     * @type {number}
     * @memberof SiegeLieuSuiviFichierSearchDto
     */
    idsiegeSocialLieuFormationSuivi?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof SiegeLieuSuiviFichierSearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof SiegeLieuSuiviFichierSearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof SiegeLieuSuiviFichierSearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SiegeLieuSuiviFichierSearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof SiegeLieuSuiviFichierSearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof SiegeLieuSuiviFichierSearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the SiegeLieuSuiviFichierSearchDto interface.
 */
export function instanceOfSiegeLieuSuiviFichierSearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SiegeLieuSuiviFichierSearchDtoFromJSON(json: any): SiegeLieuSuiviFichierSearchDto {
    return SiegeLieuSuiviFichierSearchDtoFromJSONTyped(json, false);
}

export function SiegeLieuSuiviFichierSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiegeLieuSuiviFichierSearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileName': !exists(json, 'fileName') ? undefined : UnaccentTextSearchFromJSON(json['fileName']),
        'uploadUser': !exists(json, 'uploadUser') ? undefined : UnaccentTextSearchFromJSON(json['uploadUser']),
        'uploadDate': !exists(json, 'uploadDate') ? undefined : DateSearchFromJSON(json['uploadDate']),
        'idtypeSuiviFichier': !exists(json, 'idtypeSuiviFichier') ? undefined : Int32NullableListSearchFromJSON(json['idtypeSuiviFichier']),
        'idsiegeSocialLieuFormationSuivi': !exists(json, 'idsiegeSocialLieuFormationSuivi') ? undefined : json['idsiegeSocialLieuFormationSuivi'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function SiegeLieuSuiviFichierSearchDtoToJSON(value?: SiegeLieuSuiviFichierSearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileName': UnaccentTextSearchToJSON(value.fileName),
        'uploadUser': UnaccentTextSearchToJSON(value.uploadUser),
        'uploadDate': DateSearchToJSON(value.uploadDate),
        'idtypeSuiviFichier': Int32NullableListSearchToJSON(value.idtypeSuiviFichier),
        'idsiegeSocialLieuFormationSuivi': value.idsiegeSocialLieuFormationSuivi,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

